<div class="container">
  <div class="row">
    <div class="col mb-3">
      <h5 class="pb-4 text-center text-secondary-700">{{modalConfiguration.subtitle}}</h5>
      <small class="text-center d-block text-secondary-700" [innerHTML]="modalConfiguration.content">

      </small>
    </div>
  </div>

  <div class="row justify-content-md-center my-4 row-gap-3">
    <div class="col-lg-4 col-md-12">
      <button type="button" class="btn btn-outline-secondary w-100" (click)="activeModal.close({tryAnother: true})">
        Try another address
      </button>
    </div>
  </div>
</div>